import {Ajaxinate} from "ajaxinate";

initBlogAjaniate();

function initBlogAjaniate() {
  let ajaxinateContainer = document.getElementById("AjaxinateContainer");
  let ajaxinatePagination = document.getElementById("AjaxinatePagination");

  if (!ajaxinateContainer || !ajaxinatePagination) {
    return;
  }

  console.log('start ajaxinate');

  new Ajaxinate({
    container: '#AjaxinateContainer',
    pagination: '#AjaxinatePagination',
    method: 'click',
    loadingText: 'Loading more...',
  });
}
